<app-option-bar [type]="moduleType" [details]="moduleDetails"
  (projectwebConfigtool)="projectConfigWebTool($event)"></app-option-bar>
<div class="certification-section">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [details]="moduleDetails" [type]="moduleType"></app-left-menu>
      </div>
      <div class="inner-content collapsed">
        <div class="common-section" *ngIf="!isReviewed">
          <div class="common-heading">{{ getCurrentReviewState ? "Review is under progress" : "Request admin to Review"
            }}</div>
          <div class="common-table">
            <div>
              <div class="extra-box" *ngIf="!isReviewed && getCurrentReviewState === null">
                <form [formGroup]="form" (ngSubmit)="requestCertify()" novalidate>
                  <div class="row" formGroupName="activeTask">
                    <div class="col">
                      Comment <span class="error-msg">*</span>
                      <textarea name="comment" formControlName="comment" class="form-control" rows="3" cols="80"
                        required></textarea>
                    </div>
                    <div class="col-12 mt-2">
                      <button type="submit" class="btn btn-success btn-sm" [disabled]="form.invalid">Request</button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="table-responsive" *ngIf="getCurrentReviewState">
                <table class="table">
                  <thead>
                    <tr>
                      <th width="20%">Date</th>
                      <th width="10%">Comment</th>
                      <th width="10%">Operation Type</th>
                      <th width="10%">State</th>
                      <th>Review comment <span class="text-danger">*</span></th>
                      <th width="10%">Action</th>
                    </tr>
                  </thead>
                  <tr *ngIf="getCurrentReviewState === null">
                    <td>No data found</td>
                  </tr>
                  <tr>
                    <td>{{ getCurrentReviewState.createdOn | localDate }}</td>
                    <td>{{ getCurrentReviewState.allTasks[0].comment }}</td>
                    <td>{{ getCurrentReviewState.operationType }}</td>
                    <td>{{ getCurrentReviewState.operationState }}</td>
                    <td>
                      <textarea cols="3" class="form-control" [(ngModel)]="reviewComment"></textarea>
                    </td>
                    <td>
                      <i class="fas fa-ban clickable m-1 PENDING" [appPermission]="[ADMIN, DEVELOPER, TESTER]"
                        (click)="reviewAction(null)" title="Abort" ngbTooltip="Abort"></i>
                      <i class="fas fa-check-circle clickable m-1 PASSED" [appPermission]="[ADMIN]"
                        (click)="reviewAction(APPROVE)" title="Approve" ngbTooltip="Approve"></i>
                      <i class="fas fa-times clickable m-1 FAILED" [appPermission]="[ADMIN]"
                        (click)="reviewAction(REJECT)" title="Reject" ngbTooltip="Reject"></i>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="common-section">
          <div class="common-heading">Review Process Summary</div>
          <div class="common-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th width="20%">Change Date</th>
                    <th width="20%">Change By</th>
                    <th>Comment</th>
                    <th width="10%" class="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="reviewHistoryList.length === 0">
                    <td colspan="4">No data found</td>
                  </tr>
                  <tr *ngFor="let item of reviewHistoryList">
                    <td>{{ item.executedOn | localDate }}</td>
                    <td>{{ item.executedBy.emailId }}</td>
                    <td>{{ item.comment }}</td>
                    <td class="text-center">
                      <span class="bold" [class.text-success]="item.operationState === 'APPROVED'"
                        [class.text-warning]="item.operationState === 'IN_REVIEW'"
                        [class.text-muted]="item.operationState === 'REJECTED'">{{ item.operationState }}</span>
                      <!-- [ngClass]="{'approved' : item.operationState == 'APPROVED' , 'in-review' : item.operationState == 'IN_REVIEW','rejected' : item.operationState == 'REJECTED'}" -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>